import { QUARTERS_STRING, QUARTERS } from 'helper/const';

const quarterLower = val => (val ? val.toLowerCase() : '');
export const NORMAL_FIELDS = ['number'];
export const FILE_FIELDS = [
  'documents.ifta_license_current_year',
  'documents.ifta_license_previous_years',
  ...QUARTERS_STRING.map(
    q => `documents.ifta_${quarterLower(q)}_return_current_year`
  ),
  ...QUARTERS_STRING.map(
    q => `documents.ifta_${quarterLower(q)}_receipt_current_year`
  ),
  ...QUARTERS_STRING.map(
    q => `documents.ifta_${quarterLower(q)}_return_previous_year`
  ),
  ...QUARTERS_STRING.map(
    q => `documents.ifta_${quarterLower(q)}_receipt_previous_year`
  ),
  ...QUARTERS_STRING.map(
    q => `documents.ifta_${quarterLower(q)}_totals_current_year`
  ),
  ...QUARTERS_STRING.map(
    q => `documents.ifta_${quarterLower(q)}_totals_previous_year`
  ),
];
export const NULL_FIELDS = ['state_id'];
export const NUMBER_FIELDS = [];
export const DATE_FIELDS = ['expiration_date'];
export const BODY_REQUEST_NORMAL_FIELDS = ['number'];
export const PORTAL_FIELDS = ['state_id', 'username', 'password'];
// Fields for view mode
export const PROFILE_OBJ_KEYS = [
  {
    label: 'IFTA Number',
    key: 'number',
    type: 'value',
  },
];
export const LICENSE_OBJ_KEYS = year => {
  return [
    {
      label: 'IFTA License',
      key: `year_wise.${year}.documents.ifta_license_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    },
  ];
};
export const LICENSE1_OBJ_KEYS = year => {
  const returnArr = [];
  QUARTERS.forEach(obj => {
    returnArr.push({
      label: `${obj.label} Return`,
      key: `year_wise.${year}.documents.ifta_q${obj.value}_return_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    });
    returnArr.push({
      label: `${obj.label} Receipt`,
      key: `year_wise.${year}.documents.ifta_q${obj.value}_receipt_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    });
  });
  return returnArr;
};
export const LICENSE2_OBJ_KEYS = year => {
  const returnArr = [];
  QUARTERS.forEach(obj => {
    returnArr.push({
      label: `${obj.label} Totals`,
      key: `year_wise.${year}.documents.ifta_q${obj.value}_totals_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    });
  });
  return returnArr;
};
const QUARTERLY_FILINGS_CURRENT_YEAR_OBJ_KEYS = [];
const QUARTERLY_TOTALS_CURRENT_YEAR_OBJ_KEYS = [];
const QUARTERLY_FILINGS_PREVIOUS_YEAR_OBJ_KEYS = [];
const QUARTERLY_TOTALS_PREVIOUS_YEAR_OBJ_KEYS = [];
QUARTERS_STRING.map(q => {
  QUARTERLY_FILINGS_CURRENT_YEAR_OBJ_KEYS.push({
    label: `${q} Return`,
    key: `documents.ifta_${quarterLower(q)}_return_current_year`,
    type: 'file',
    isSingleFile: true,
  });
  QUARTERLY_FILINGS_CURRENT_YEAR_OBJ_KEYS.push({
    label: `${q} Receipt`,
    key: `documents.ifta_${quarterLower(q)}_receipt_current_year`,
    type: 'file',
    isSingleFile: true,
  });
  QUARTERLY_TOTALS_CURRENT_YEAR_OBJ_KEYS.push({
    label: `${q} Totals`,
    key: `documents.ifta_${quarterLower(q)}_totals_current_year`,
    type: 'file',
    isSingleFile: true,
  });
  QUARTERLY_FILINGS_PREVIOUS_YEAR_OBJ_KEYS.push({
    label: `${q} Return`,
    key: `documents.ifta_${quarterLower(q)}_return_previous_year`,
    type: 'file',
  });
  QUARTERLY_FILINGS_PREVIOUS_YEAR_OBJ_KEYS.push({
    label: `${q} Receipt`,
    key: `documents.ifta_${quarterLower(q)}_receipt_previous_year`,
    type: 'file',
  });
  QUARTERLY_TOTALS_PREVIOUS_YEAR_OBJ_KEYS.push({
    label: `${q} Totals`,
    key: `documents.ifta_${quarterLower(q)}_totals_previous_year`,
    type: 'file',
  });
  return true;
});
export {
  QUARTERLY_FILINGS_CURRENT_YEAR_OBJ_KEYS,
  QUARTERLY_TOTALS_CURRENT_YEAR_OBJ_KEYS,
  QUARTERLY_FILINGS_PREVIOUS_YEAR_OBJ_KEYS,
  QUARTERLY_TOTALS_PREVIOUS_YEAR_OBJ_KEYS,
};
